import type { JobApplication, Job } from '@cibli/shared';

import { useEffect, useState } from 'react';

import { getUserJobApplications } from '../services/job';

export function useUserJobApplications() {
  const [applications, setApplications] = useState<JobApplication[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchApplications = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getUserJobApplications();
      setApplications(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch applications'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    void fetchApplications();
  }, []);

  const hasAppliedToJob = (job: Job | { id: string }): boolean => {
    return applications.some((app: JobApplication) => app.jobId === job.id);
  };

  const refetch = () => {
    void fetchApplications();
  };

  return {
    applications,
    isLoading,
    error,
    hasAppliedToJob,
    refetch,
  };
}
